/**
 * 防抖
 *
 */
function MyDebounce(fn, duration = 100) {
	let timer = null;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => {
			fn.apply(this, args);
		}, duration);
	};
}
/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
	let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let Y = date.getFullYear() + "-";
	let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
	let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
	let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
	let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
	let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
	return Y + M + D + h + m + s;
};
/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
const formatTime = (time, fmt) => {
	if (!time) return "";
	else {
		const date = new Date(time);
		const o = {
			"M+": date.getMonth() + 1,
			"d+": date.getDate(),
			"H+": date.getHours(),
			"m+": date.getMinutes(),
			"s+": date.getSeconds(),
			"q+": Math.floor((date.getMonth() + 3) / 3),
			S: date.getMilliseconds()
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (const k in o) {
			if (new RegExp("(" + k + ")").test(fmt)) {
				fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
			}
		}
		return fmt;
	}
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== "string") {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = (name) => {
	if (!name) return;
	return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = (name) => {
	if (!name) return;
	window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
	let date = new Date();
	date.setDate(date.getDate() + day);
	document.cookie = name + "=" + value + ";expires=" + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
	let reg = RegExp(name + "=([^;]+)");
	let arr = document.cookie.match(reg);
	if (arr) {
		return arr[1];
	} else {
		return "";
	}
}

/**
 * 删除cookie
 **/
function delCookie(name) {
	setCookie(name, null, -1);
}

/**
 * MD5加密
 * @param {string} str 需要加密的字符串
 * @returns {string} 加密后的字符串
 */
const md5 = require("js-md5");
const encryptMD5 = (str) => {
	return md5(str);
};

/**
 * 导出
 **/
export { MyDebounce, timestampToTime, formatTime, setStore, getStore, removeStore, setCookie, getCookie, delCookie, encryptMD5 };
